import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicPagesRoutingModule } from './dynamic-pages-routing.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    DynamicPagesRoutingModule
  ]
})
export class DynamicPagesModule { }
